import { drawSpinningLogo } from './p5logo.js';

export function loader(useLogo = false, startDelay = 30) {

	const loadingWords = ["Loading...", "Cargando..", "로딩중...", "読み込み中...", "...يتم التحميل", "加载中...", "Chargement...", "Laden..."];
	shuffle(loadingWords, true); // Randomize languages to avoid implying a hierarchy
	const bgColor = color("#222222");
	const logoColor = color("#FFFFFF");
	const textColorLight = color("#DDDDDD");
	const textColorDark = color("#555555");
	let isLoaderShown = true;
	let frame = 0;
	let isMouseInside = false;
	let hasMouseMoved = false;

	background(bgColor);

	// Wait for canvas to be ready before adding event listeners
	setTimeout(() => {
		createMouseInsideListener();
		createMouseMoveListener();
	}, 0);

	function animation() {
		background(bgColor);
		textAlign(LEFT, TOP);
		const fontSize = 16;
		textSize(fontSize);
		const spacing = fontSize * 1.4;

		for (let i = 0; i < loadingWords.length; i++) {
			const wave = map(sin(frame * 0.05 - i * 0.5), -1, 1, 0, 1);
			const greyValue = lerpColor(textColorDark, textColorLight, wave);

			fill(greyValue);
			text(`${loadingWords[i]}`, 20, 20 + i * spacing);
		}

		if (useLogo && isMouseInside && hasMouseMoved) {
			noCursor();
			drawSpinningLogo(mouseX, mouseY, frame, logoColor);
		}
	}

	function show() {
		if (!isLoaderShown) return;

		frame += 1;

		// Wait a few frames before playing the loading animation
		if (frame > startDelay) {
			clear();
			animation();
		}

		setTimeout(() => {
			requestAnimationFrame(show);
		}, 1000 / 60);
	}
	show();

	// Will check whether the mouse is inside the canvas
	function createMouseInsideListener() {
		const canvas = document.querySelector('canvas');
		if (canvas) {
			canvas.addEventListener('mouseenter', () => {
				isMouseInside = true;
			});
			canvas.addEventListener('mouseleave', () => {
				isMouseInside = false;
			});
		}
	}

	// Will check whether the mouse has moved at least once
	function createMouseMoveListener() {
		const canvas = document.querySelector('canvas');
		if (canvas) {
			canvas.addEventListener('mousemove', (e) => {
				hasMouseMoved = true;
				isMouseInside = true; // Also set this when mouse moves
			}, {
				once: true
			}); // Only trigger the first time
		}
	}

	// Plug into the post-setup hook to hide the loader
	// after the setup function has completed
	p5.lifecycleHooks.postsetup.push(() => {
		cursor();
		isLoaderShown = false;
	});
}
